import CardWithShadow from "@/components/CardWithShadow";
import ChevronButton from "@/components/ChevronButton";
import Divider from "@/components/Divider";
import Text from "@/components/Text";
import Theme from "@/utils/theme";
import { Box } from "@mui/material";

import { REGULATION_KEY_DATES } from "./keyDates";
import { useRegulation } from "./useRegulation";

export default function Regulation() {
  const { onOpenRegulation } = useRegulation();

  return (
    <Box display="flex" flexDirection="column">
      <CardWithShadow
        flexDirection="row"
        alignItems="center"
        maxWidth="max-content"
        alignSelf={{ xs: "center", lg: "inherit" }}
      >
        <Box
          p="1rem"
          flexDirection="row"
          alignItems="center"
          borderRight="1px solid"
          borderColor={Theme.colors.neutral.light}
        >
          <Text fontSize="1rem" ml="0.5rem">
            REGULAMENTO
          </Text>
        </Box>

        <Box flexDirection="row" p="1rem" gap="1rem">
          <ChevronButton
            label="Abrir Regulamento"
            onClick={onOpenRegulation}
          ></ChevronButton>
        </Box>
      </CardWithShadow>

      <CardWithShadow mt="1rem" p="1rem 1.5rem">
        <Text fontWeight={600} mb="1rem" color={Theme.colors.text.primary}>
          Principais prazos
        </Text>

        <Box display="flex" flexDirection="column" gap={0}>
          {REGULATION_KEY_DATES.map((row, index) => (
            <Box key={row.label}>
              {index > 0 && <Divider margin="0.75rem 0" />}
              <Box
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
                justifyContent="space-between"
                gap={{ xs: "0.35rem", sm: "1rem" }}
                alignItems={{ xs: "flex-start", sm: "center" }}
              >
                <Text color={Theme.colors.text.secondary} fontWeight={500}>
                  {row.label}
                </Text>
                <Text
                  color={Theme.colors.text.primary}
                  fontWeight={600}
                  textAlign={{ xs: "left", sm: "right" }}
                >
                  {row.dateText}
                </Text>
              </Box>
            </Box>
          ))}
        </Box>

        <Box mt="1.25rem">
          <Text color={Theme.colors.text.tertiary} fontSize="0.9rem">
            Consulte os detalhes no regulamento completo.
          </Text>
        </Box>
      </CardWithShadow>
    </Box>
  );
}
